<template>
    <div class="daterange">
        <datepicker
            :format="dateFormat"
            :language="zh"
            :value="start"
            @selected="selectStart"
            :disabledDates="startDisabledDates">
        </datepicker>
        <i>-</i>
        <datepicker
            :format="dateFormat"
            :language="zh"
            :value="end"
            @selected="selectEnd"
            :disabledDates="endDisabledDates">
        </datepicker>
    </div>
</template>
<script>
import { zh } from 'vuejs-datepicker/dist/locale'
import Datepicker from 'vuejs-datepicker'

const dateFormat = (date) => {
    const originMonth = date.getMonth() + 1
    const monthStr = originMonth < 10 ? `0${originMonth}` : originMonth
    const originDate = date.getDate()
    const dayStr = originDate < 10 ? `0${originDate}` : originDate
    const dateStr = `${date.getFullYear()}-${monthStr}-${dayStr}`
    return dateStr
}

const currentDate = new Date()

const DEFAULT_DATE = dateFormat(currentDate)

export default {
    data () {
        return {
            zh,
            start: DEFAULT_DATE,
            end: DEFAULT_DATE,
            startDisabledDates: {
                from: currentDate
            },
            endDisabledDates: {
                to: currentDate
            }
        }
    },
    methods: {
        dateFormat (date) {
            return dateFormat(date)
        },
        selectStart (date) {
            this.endDisabledDates = {
                to: date
            }
            this.start = dateFormat(date)
            this.changeDate()
        },
        selectEnd (date) {
            this.startDisabledDates = {
                from: date
            }
            this.end = dateFormat(date)
            this.changeDate()
        },
        changeDate () {
            this.$emit('change', this.start, this.end)
        }
    },
    components: {
        Datepicker
    }
}
</script>
<style lang="scss" scoped>
.daterange {
    display: inline-flex;
    margin-left: 20px;
    justify-content: flex-start;
    align-items: center;
    height: 40px;
    > i {
        margin: 0 5px;
    }
}
</style>
